import { makeImageUrls } from "@ezbuy/smartimagesrc";
import { TMagicItem, TIconModule, TCouponModule } from "services/page/admin";
import { genPrmLink } from "utils/url";
import { TBannerItem as BannerItemProps } from "optimus-front/lib/services/banner";
import { RenderCoupon } from "optimus-front/lib/pc/views/CouponCode";
import Constant from "utils/isomorphismConstant";
import { multilingualImgDisplay } from "utils/mutil-Language";
import { PrmParams } from "../prm";
import { isNotBlankArray } from "utils/array";

export const fetchPosterWithBetter = (url: string) => {
	return makeImageUrls(url, {
		online: true,
		keepSize: true,
	})[0];
};

export const litbBlankPoster = () =>
	fetchPosterWithBetter("https://i.ezbuy.sg/FluV4tzjHziGlXdVl45rNBLROybL");

export const litbErrorPoster = () =>
	fetchPosterWithBetter("https://i.ezbuy.sg/FibTB_cZNkWsEG1AXLl4caVm6ydT");

// 普通图片占位图
export const bannerPlaceholder = "https://i.ezbuy.sg/FluV4tzjHziGlXdVl45rNBLROybL";
export const formatAspect = (side: string | number) => {
	if (typeof side === "string" && isNaN(+side)) {
		return 0;
	}
	return +side;
};

export const transformMagicLinks = (index: number, items: TMagicItem[] = []) => {
	if (isNotBlankArray(items)) {
		return items.map((item, i) => ({
			...item,
			link: genPrmLink(
				{
					floor: index + 1,
					position: i + 1,
				},
				item.link,
			),
		}));
	}
	return items;
};

export const transformNavIcons = (
	navs: TIconModule[],
	prm: PrmParams,
): { bgColor: string; navs: BannerItemProps[] } => {
	const bgColor = navs?.[0].ui?.bgColor;
	const nextNavs = navs.reduce((result: BannerItemProps[], nav: TIconModule, index: number) => {
		const { img, link, title, width, height, bgColor } = transformTIconModule(nav, {
			...prm,
			position: index,
		});
		const nextNav: BannerItemProps = {
			img,
			link,
			text: title,
			width,
			height,
			bgColor,
		};
		return [...result, nextNav];
	}, []);
	return {
		bgColor,
		navs: nextNavs,
	};
};

export const transformTIconModule = (iconMod: TIconModule, prm: PrmParams) => {
	const { icon = {}, ui = {} } = iconMod;
	const ig = icon?.ig?.igroup?.[Constant.language] || {};
	const { floor, position = 0 } = prm;
	return {
		img: ig.img || icon?.img,
		imgTwo: ig.imgTwo || icon.imgTwo,
		link: genPrmLink(
			{
				floor,
				position,
			},
			icon.link,
		),
		title: ig.text || icon?.title,
		width: icon?.width,
		height: icon.height,
		bgColor: ui?.bgColor || "#fff",
	};
};

export const tranformCouponInfo = (coupons: TCouponModule[] = []): RenderCoupon[] => {
	const resCoupon: RenderCoupon[] = [];
	coupons.map((item: TCouponModule) => {
		resCoupon.push({
			img: multilingualImgDisplay(item.info),
			code: item.couponCode,
			width: +item.info.width,
			height: +item.info.height,
		});
	});

	return resCoupon.filter((ele) => !!ele?.img);
};
